/** The etched legends printed on the plinth. */

import * as THREE from 'three';
import { DIM } from '../../geometry/dims.ts';
import { type DecalOptions, decalTexture } from '../../textures/decals.ts';
import type { DeckMaterials } from '../materials.ts';

interface Legend {
  text: string;
  x: number;
  z: number;
  w: number;
  h: number;
  options: DecalOptions;
}

const QUIET = 'rgba(96,108,102,0.85)';
const FAINT = 'rgba(120,132,126,0.8)';

const LEGENDS: readonly Legend[] = [
  { text: 'START / STOP', x: -21.0, z: 11.9, w: 6.2, h: 1.2, options: { size: 48, color: QUIET } },
  { text: 'PITCH', x: 20.4, z: 0.6, w: 5.2, h: 1.2, options: { size: 52, color: QUIET } },
  { text: '+8', x: 16.6, z: 1.7, w: 2.4, h: 1.0, options: { size: 54, color: FAINT } },
  { text: '-8', x: 16.6, z: 14.3, w: 2.4, h: 1.0, options: { size: 54, color: FAINT } },
  { text: 'POWER', x: -21.6, z: -14.6, w: 5.0, h: 1.1, options: { size: 50, color: FAINT } },
  {
    text: 'TURNTABLE',
    x: 8.0,
    z: 18.4,
    w: 12.0,
    h: 1.8,
    options: { size: 62, weight: 700, letterSpacing: '0.30em', color: 'rgba(72,84,78,0.55)' },
  },
];

export function buildLegends(root: THREE.Group, M: DeckMaterials): void {
  for (const l of LEGENDS) {
    const mesh = new THREE.Mesh(
      new THREE.PlaneGeometry(l.w, l.h),
      M.decal(decalTexture(l.text, l.options)),
    );
    mesh.rotation.x = -Math.PI / 2;
    mesh.position.set(l.x, DIM.top + 0.02, l.z);
    root.add(mesh);
  }
}
